(function() {
  const STORAGE_KEY = 'wildgrain-custom-box-state';

  // Get custom box state from localStorage
  function getBoxState() {
    try {
      const state = localStorage.getItem(STORAGE_KEY);
      return state ? JSON.parse(state) : null;
    } catch (e) {
      console.error('Error parsing custom box state:', e);
      return null;
    }
  }

  // Calculate total items in box
  function getTotalBoxItems(productQuantities) {
    return Object.values(productQuantities || {}).reduce((sum, qty) => sum + qty, 0);
  }

  // Get box size as a number
  function getBoxSize(selectedSize) {
    const match = selectedSize ? selectedSize.match(/(\d+)/) : null;
    return match ? parseInt(match[1]) : 0;
  }

  // Check if product should show as add-on
  function isProductAddon(productId, boxState) {
    if (!boxState) {
      return false;
    }

    // Check if box is full
    if (boxState.boxFull) {
      return true;
    }

    // Check if box size is set and calculate if full
    if (boxState.selectedSize && boxState.productQuantities) {
      const totalItems = getTotalBoxItems(boxState.productQuantities);
      const boxSize = getBoxSize(boxState.selectedSize);
      if (totalItems >= boxSize) {
        return true;
      }
    }

    // Check if product is not in available products
    if (boxState.availableProducts && Array.isArray(boxState.availableProducts)) {
      const isAvailable = boxState.availableProducts.includes(parseInt(productId));
      if (!isAvailable) {
        return true;
      }
    }

    return false;
  }

  // Update addon badge visibility for quick view modal
  function updateQuickViewAddonBadge(modalElement) {
    if (!modalElement) return;

    // Get product ID from the modal
    const productInfoElement = modalElement.querySelector('[id^="ProductInfo-"]');
    if (!productInfoElement) return;

    const productUrl = productInfoElement.dataset.url;
    if (!productUrl) return;

    // Extract product ID from URL or data attribute
    const productIdMatch = productUrl.match(/\/products\/[^\/]+\/(\d+)/);
    const productId = productIdMatch ? productIdMatch[1] : null;

    // If we can't get product ID from URL, try to get it from form
    if (!productId) {
      const formButtons = modalElement.querySelector('.product-form__buttons');
      if (!formButtons || !formButtons.dataset.productId) return;
      var extractedProductId = formButtons.dataset.productId;
    } else {
      var extractedProductId = productId;
    }

    const boxState = getBoxState();
    const shouldShowAddon = isProductAddon(extractedProductId, boxState);

    // Find the badges container (where "Save 12%" badge lives)
    const badgesBlock = modalElement.querySelector('.product__badges');
    if (!badgesBlock) return;

    let badge = badgesBlock.querySelector('.quick-view-addon-badge');

    if (shouldShowAddon) {
      // Create badge if it doesn't exist
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'quick-view-addon-badge f-badge';
        badge.textContent = 'Add-on';
        // Insert at the beginning of the badges block (before "Save 12%" badge)
        badgesBlock.insertBefore(badge, badgesBlock.firstChild);
      }
      badge.classList.add('visible');
    } else {
      // Hide badge if it exists
      if (badge) {
        badge.classList.remove('visible');
      }
    }
  }

  // Update all open quick view modals
  function updateAllQuickViewModals() {
    const modals = document.querySelectorAll('quick-view-modal');
    modals.forEach(modal => {
      // Only update if modal is visible (not hidden)
      if (!modal.hasAttribute('hidden')) {
        updateQuickViewAddonBadge(modal);
      }
    });
  }

  // Listen for quick view loaded event
  document.addEventListener('quick-view:loaded', function() {
    requestAnimationFrame(() => {
      const modal = document.querySelector('quick-view-modal[open]');
      if (modal) {
        updateQuickViewAddonBadge(modal);
      }
    });
  });

  // Close quick view modal when items are added to box or addon
  function closeQuickViewModal() {
    const openModal = document.querySelector('quick-view-modal:not([hidden])');
    if (openModal && typeof openModal.hide === 'function') {
      openModal.hide();
    }
  }

  // Listen for custom box state changes (when "Add To Your Box" is clicked)
  window.addEventListener('customBoxStateChanged', function(event) {
    // Update addon badges
    updateAllQuickViewModals();
    // Close modal when item is added to box
    closeQuickViewModal();
  });

  // Listen for storage changes (when state changes in another tab)
  window.addEventListener('storage', function(e) {
    if (e.key === STORAGE_KEY) {
      updateAllQuickViewModals();
    }
  });

  // Listen for cart updates (when items are added as addon)
  document.addEventListener('cart:updated', closeQuickViewModal);
  
  // Listen for product added events (when items are added to cart)
  document.addEventListener('product-ajax:added', closeQuickViewModal);
  
  // Listen for checkout addons adding to cart
  document.addEventListener('checkout-addons:adding-to-cart', closeQuickViewModal);

  // Initial check when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllQuickViewModals);
  } else {
    updateAllQuickViewModals();
  }

  // Apply nutrition color to dynamically loaded content
  function applyNutritionColor(modal) {
    if (!modal) return;
    
    const nutritionColor = modal.getAttribute('data-nutrition-color');
    if (!nutritionColor) return;

    // Apply color to nutrition facts elements
    const nutritionFacts = modal.querySelectorAll('.nutrition-facts, .nutrition-facts *');
    nutritionFacts.forEach(el => {
      el.style.color = nutritionColor + ' !important';
      if (el.style.borderColor) {
        el.style.borderColor = nutritionColor + ' !important';
      }
    });

    // Apply color to h1 headings
    const headings = modal.querySelectorAll('h1');
    headings.forEach(h1 => {
      h1.style.color = nutritionColor + ' !important';
    });

    // Apply color to collapsible tab headings
    const collapsibleHeadings = modal.querySelectorAll('.collapsible-tab__heading, h4.collapsible-tab__heading');
    collapsibleHeadings.forEach(heading => {
      heading.style.color = nutritionColor + ' !important';
    });

    // Apply color to View Full Details button
    const viewDetailsButtons = modal.querySelectorAll('.product__view-details, .btn--primary.product__view-details');
    viewDetailsButtons.forEach(button => {
      button.style.setProperty('background-color', nutritionColor, 'important');
      button.style.setProperty('border-color', nutritionColor, 'important');
      button.style.setProperty('color', '#ffffff', 'important');
    });

    // Apply color to Add To Your Box / Add to Cart button
    const addToCartButtons = modal.querySelectorAll('.product-form__submit, .product-form__submit.btn--primary, .product-form__buttons .btn--primary');
    addToCartButtons.forEach(button => {
      button.style.setProperty('background-color', nutritionColor, 'important');
      button.style.setProperty('border-color', nutritionColor, 'important');
      button.style.setProperty('color', '#ffffff', 'important');
    });

    // Apply color to baking instructions bullet points using CSS injection
    let styleEl = modal.querySelector('#dynamic-nutrition-styles');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'dynamic-nutrition-styles';
      modal.appendChild(styleEl);
    }
    styleEl.textContent = `
      quick-view-modal[data-nutrition-color="${nutritionColor}"] .baking-instructions ol li:before {
        background: ${nutritionColor} !important;
      }
    `;
  }

  // Listen for quick view loaded event and apply colors
  document.addEventListener('quick-view:loaded', function() {
    requestAnimationFrame(() => {
      const modal = document.querySelector('quick-view-modal[open]');
      if (modal) {
        applyNutritionColor(modal);
      }
    });
  });
})();
